import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss';

const Checkbox = ({checked, disabled, clickHandler, hasErrors, ...props}) => {

    const [isFocused, setIsFocused] = useState(false);
    const onClickHandler = disabled ? () => null : clickHandler;
    const classes = [styles.customCheckboxContainer];
    if (disabled) classes.push(styles.customCheckboxDisabled);
    if (checked) classes.push(styles.customCheckboxChecked);
    if (hasErrors) classes.push(styles.customCheckboxHasErrors);

    return (
        <div className={classes.join(' ')}
             role={'form'}
             tabIndex={0}
             onFocus={() => setIsFocused(true)}
             onBlur={() => setIsFocused(false)}
             onKeyDown={isFocused ? e => {if (e.key === ' ') onClickHandler();} : null}>
            {checked ? <div className={styles.dotInside}/> : null}
        </div>
    );
};

Checkbox.propTypes = {
    disabled: PropTypes.bool,
    hasErrors: PropTypes.bool,
    checked: PropTypes.bool,
    clickHandler: PropTypes.func,
};

Checkbox.defaultProps = {
    disabled: false,
    hasErrors: false,
    checked: false,
    clickHandler: () => null,
};

export default Checkbox;
